const MatchResults = {
  WIN: 'W',
  LOSS: 'L',
  DRAW: 'D',
} as const;

export default MatchResults;
